module.exports = __webpack_public_path__ + "img/zocodec.e90331d1.png";